import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

type TeamBarProps = {
  percent: string
  teamColor: string
  teamName?: string
}

type FilledBarProps = {
  side: 'left' | 'right'
  teamColor: string
}

type ColProps = {
  teamColor: string
}

export const BarHead = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(0),
  '& h3': {
    textAlign: 'center',
    color: colors.white,
    fontSize: fontSizes.semiLarge,
    fontWeight: 700,
    margin: 0,
  },
  '& p': {
    textAlign: 'center',
    color: colors.white,
    fontSize: fontSizes.medium,
    margin: 0,
  },
}))

export const BarOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '100%',
  margin: theme.spacing(1, 0),
  '& a': {
    color: colors.offWhite,
    fontWeight: 700,
    fontSize: fontSizes.medium,
  },
}))

export const BarCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  borderRadius: 12,
  margin: theme.spacing(2, 0),
  '& :nth-of-type(1)': {
    borderRadius: '12px 0 0 12px',
  },
  '& :last-child': {
    borderRadius: '0 12px 12px 0',
  },
}))

export const ResultsHead = styled('div')(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  fontSize: fontSizes.semiLarge,
  color: colors.white,
  margin: theme.spacing(0),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))

export const FanPickCon = styled('div')<ColProps>(({ teamColor, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  borderRadius: 12,
  '& .col': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '70%',
    margin: theme.spacing(0, 1),
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
    '& img': {
      height: 50,
      marginBottom: theme.spacing(1),
    },
    '& h3': {
      fontSize: fontSizes.large,
      color: teamColor,
      fontWeight: 700,
      margin: 0,
    },
    '& p': {
      fontSize: fontSizes.medium,
      color: colors.text,
      textAlign: 'center',
      margin: theme.spacing(0),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
  },
}))

export const ProbabilitiesChartsCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  // '& .percentCon': {
  //   position: 'relative',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)',
    
  // },
}))

export const TeamFilled = styled('div')<TeamBarProps>(
  ({ percent, teamColor, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    background: `${teamColor}`,
    width: `${percent}%`,
    minWidth: 40,
    height: 65,
    [theme.breakpoints.down('sm')]: {
      minWidth: 35,
      height: 55,
    },
    '& .con': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& img': {
        height: 30,
        marginBottom: theme.spacing(0.5),
        [theme.breakpoints.down('sm')]: {
          height: 25,
        },
      },
      '& .percent': {
        fontSize: fontSizes.medium,
        fontWeight: 700,
        color: colors.white,
        marginBottom: 3,
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.7rem',
        },
      },
    },
  })
)

export const FilledBar = styled('div')<FilledBarProps>(({ side, teamColor, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: side === 'left' ? 'flex-end' : 'flex-start',
  alignItems: 'center',
  background: `${teamColor}`,
  width: '100%',
  borderRadius: side === 'right' ? '0 12px 12px 0' : '12px 0 0 12px',
  margin: side === 'left' ? theme.spacing(0, 0.5, 1, 3) : theme.spacing(0, 3, 1, 0.5),
  '& .percent': {
    fontSize: fontSizes.large,
    fontWeight: 700,
    color: colors.white,
    margin: theme.spacing(0, 1, 0),
  },
}))